import { stats } from 'instantsearch.js/es/widgets';

export default function Stats(container = '#stats') {
	return stats({
		container,
		templates: {
			text(data, { html }) {
				let count = '';
				if (data.hasManyResults) {
					count += `${data.nbHits} ${strl_vars.more_results}`;
					return html`<span>${count}</span>`;
				} else if (data.hasOneResult) {
					count += `1 ${strl_vars.one_result}`;
					return html`<span>${count}</span>`;
				} else {
					return '';
				}
			},
		},
		cssClasses: {
			text: 'text-secondary-140',
		},
	});
}
